import Hero from "../../components/Hero";
import CalculatorsImag1 from "../../../assets/images/Calculator1.jpg";
import RelevantLifeTaxCalculator from "../../calculators/RelevantLifeTaxCalculator";

const RelevantLifeTaxPage = () => {
  return (
    <div>
      <Hero
        title="Relevant Life Tax"
        subtitle=""
        backgroundImage={CalculatorsImag1}
      />
      <RelevantLifeTaxCalculator/>
      {/* <div className="landing-page">
            </div> */}
    </div>
  );
};

export default RelevantLifeTaxPage;
